import { Box } from '../../common/ui/Box';

import { Pagination } from './Pagination';

interface CenteredPaginationProps {
    pageTotal: number;
    currentPage: number;
    onPageChange: (page: number) => void;
}

export const CenteredPagination = ({ pageTotal, currentPage, onPageChange }: CenteredPaginationProps) => {
    if (pageTotal <= 1) {
        return null;
    }

    return (
        <Box display="flex" justifyContent="center" marginTop={24} style={{ textAlign: 'center' }}>
            <Pagination currentPage={currentPage} pageTotal={pageTotal} onPageChange={onPageChange} />
        </Box>
    );
};
